import React from 'react';
import { Input, Button, Form } from 'antd';
import { PhoneOutlined, MailOutlined, EnvironmentOutlined } from '@ant-design/icons';
import '../../Styles/Contact.css'; // Custom CSS file

const Contact = () => {
  return (
    <section className="contact-section" aria-labelledby="contact-heading">
      <div className="contact-section-inner">
        <header className="contact-section-header">
          <p className="section-eyebrow">LET'S CONNECT</p>
          <h1 id="contact-heading">Get In Touch</h1>
          <div className="contact-title-line" aria-hidden="true" />
          <p className="contact-description">Please feel free to contact us if you have any queries, suggestions, or complaints.</p>
        </header>
        <div className="contact-content">
          <div className="contact-left">
            <figure className="contact-image-wrap"><img src={require('../../Assets/Contact/Uni.jpg')} alt="Institute of Space Technology building" /></figure>
            <div className="contact-details">
              <div className="contact-detail"><PhoneOutlined className="contact-icon" /><span>+92-51-9675799<br />+92-51-9675578</span></div>
              <div className="contact-detail"><MailOutlined className="contact-icon" /><a href="mailto:info@ncgsa.org.pk">info@ncgsa.org.pk</a></div>
              <div className="contact-detail"><EnvironmentOutlined className="contact-icon" /><span>1, Islamabad Highway, Islamabad.</span></div>
            </div>
          </div>
          <div className="contact-right">
          <h2>How Can We Help?</h2>
          <div className="contact-title-line" aria-hidden="true" />
          <p className="contact-description">
            Alternatively, you can also mention your queries, suggestions, or complaints, and our representative will get in touch with you soon!
          </p>
          <Form
            layout="vertical"
            name="contact_form"
            className="contact-form"
          >
            <Form.Item
              label="Name*"
              name="name"
              rules={[{ required: true, message: 'Please enter your name!' }]}
            >
              <Input placeholder="Your Name" />
            </Form.Item>
            <Form.Item
              label="Email*"
              name="email"
              rules={[{ required: true, message: 'Please enter your email!' }]}
            >
              <Input placeholder="Your Email" />
            </Form.Item>
            <Form.Item
              label="How can we help?*"
              name="help"
              rules={[{ required: true, message: 'Please describe how we can help!' }]}
            >
              <Input placeholder="How can we help?" />
            </Form.Item>
            <Form.Item
              label="Message*"
              name="message"
              rules={[{ required: true, message: 'Please enter your message!' }]}
            >
              <Input.TextArea rows={4} placeholder="Your Message" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" className="contact-submit-btn">
                Contact Us
              </Button>
            </Form.Item>
          </Form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
